import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface QuestionState {
  generalCategory: any[];
  subjectAndGrade: any[];
  multipleQuestionTypes: any[];
}

const initialState: QuestionState = {
  generalCategory: [],
  subjectAndGrade: [],
  multipleQuestionTypes: [],
};

const questionSlice = createSlice({
  name: 'question',
  initialState,
  reducers: {
    setGeneralCategory: (state, action: PayloadAction<any[]>) => {
      state.generalCategory = action.payload;
    },
    setSubjectAndGrade: (state, action: PayloadAction<any[]>) => {
      state.subjectAndGrade = action.payload;
    },
    setMultipleQuestionTypes: (state, action: PayloadAction<any[]>) => {
      state.multipleQuestionTypes = action.payload;
    },
  },
});

export const {
  setGeneralCategory,
  setSubjectAndGrade,
  setMultipleQuestionTypes,
} = questionSlice.actions;

export default questionSlice.reducer;
